import { withInstall } from '@xzx-design/utils'
import _Swipe from './src/swipe.tsx'
import _SwipeItem from './src/swipe-item.tsx'

export const Swipe = withInstall(_Swipe)
export const SwipeItem = withInstall(_SwipeItem)

export default Swipe

export * from './src/swipe'
export * from './src/types'
